<!-- =========================================================================================
    File Name: KnowledgeBaseCategoryQuestion.vue
    Description: Knowledge Base Question - Answer Article
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="map" ref="map"></div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  props: {
    data: {},
  },
  data() {
    return {
      loader: null,
      map: null,
      gmarkers: [],
    };
  },
  methods: {
    emitData() {
      // Emitting a custom event named 'data-emitted' with some data
      this.$emit('data-emitted', -1);
    },
  },
  mounted() {
    const self = this;
    self.loader = new Loader(this.$loader);

    self.loader.load().then(() => {
      self.map = new google.maps.Map(self.$refs.map, {
        center: { lat: self.data.lat, lng: self.data.lng },
        zoom: 8,
        gestureHandling: 'greedy',
      });

      const marker = new google.maps.Marker({
        position: { lat: self.data.lat, lng: self.data.lng },
        label: {
          text: self.data.name,
          color: 'black',
          fontSize: '14px',
          align: 'center',
          fontWeight: 'bold',
        },
        icon: {
          labelOrigin: new google.maps.Point(0, 7),
          //   anchor:new google.maps.Point(15, 30),
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 5,
          strokeWeight: 3,
          // strokeColor: data.color,
          // rotation: data.rotation,
        },
        map: self.map,
      });
      self.gmarkers.push(marker);
      self.map.panTo(marker.position);
      self.map.setZoom(16);
    });
  },
  components: {
    Loader,
    VuePerfectScrollbar,
  },
};
</script>

<style>
#map {
  height: 30vh;
}
.scrollable-div {
  height: 99vh; /* Set the height of the div */
  overflow-y: scroll; /* Enable vertical scrolling */
  align-items: center;
}
.rounded-image {
  border-radius: 10px; /* Adjust the border radius as needed */
  border: 2px solid #ccc; /* Grey border */
  justify-content: center;
  height: 30vh;
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 33vh; /* Adjust the height of the container as needed */
}
</style>
